import { FunctionComponent, useContext } from "react";

import ScrollableContainer from "../../layout/scrollable-container";
import Footer from "../../components/footer";
import Container from "../../layout/container";

import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";

import { VectorWrapper } from "../post-transfer/styles";

import { TransferContext } from "../../context/TransferContext";
import landONMoneyVector from "./assets/landonmoney.png";
import HeadingContainer from "../../layout/heading-container";
import { HeadlineMedium } from "../../components/font";
import { Button } from "@manifesthhqinc/ui-library";

const OpenIRAExitScreen: FunctionComponent = () => {
  const { setShouldShowHomeScreen, userDetails, transferDetails } = useContext(TransferContext);

  return (
    <TransitionWrapper>
      <ScrollableContainer name="open-ira-exit-screen">
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar={false}>
            <HeadlineMedium $textAlign="center">
              You’re all set, {userDetails.firstName}!
              <br />
              Sit back and relax, {transferDetails.destinationAccount?.providerName} is currently opening your IRA.
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapper $paddingTop={20}>
            <img src={landONMoneyVector} alt="land on money" />
          </VectorWrapper>
          <p className="text-center pr-20 pl-20 pt-20">
            Your designated transfer specialist will reach out with an update once your IRA is open.
          </p>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={() => setShouldShowHomeScreen(true)} name="exit-manifest" size="large">
          Got it
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default OpenIRAExitScreen;
